import { html, css, PropertyValues } from 'lit';
import { BaseWidget } from "../base-widget";
import { property } from 'lit/decorators.js';

// Quick link default widget implementation.  This has a static content
export class MfaWorkspaceDefault extends BaseWidget {
    static get styles() {
        return css`
          .text-center { text-align: center; }
          .text-left { text-align: left; }
          .text-right { text-align: right; }
          .col-sm-12 { width: 100%; }
          .col-sm-1 { width: 8%; float: left; }
          .col-sm-11 { width: 92%;  float: left; }
          .no-padding{ padding: 0px !important;}
          .widget-content-class{padding: 16px; }
          .header-info {padding-bottom: 16px;}
          .footer-info{padding-top:16px;}
          .d-flex{display:flex;}
          .fw-bold{font-weight:bold;}
          .pl-20{padding-left: 20px;}
          .pl-12{padding-left: 12px;}
          .widgetbox {
                border: 1px solid #75787b;
                border-radius: 5px;
                background: #ffffff;
                margin-right: 15px;
                margin-bottom: 15px;
                margin-top: 10px;
                min-height: 40px;
            }
        `;
    }
    // Widget is loaded, so refresh window based on state
    firstUpdated(changedProperties: PropertyValues) {
        this.showOrHideForState();
    }


    // Overriding content part of the widget.render().  We just need a slot here!
    getContentLoaderSlot() {
        return html`
          <div class="widget-content-class">
            <div class="container-fluid">
              <div class="header-info">
                <div class="text-left col-sm-12">
                  Turning on 2FA will add extra security to your account. When
                  you login, you will use an Authentication Code in addition to
                  your password.
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">Available 2FA methods:</div>
              </div>

              <div class="d-flex">
                <div class="fw-bold">1.</div>
                <div class="pl-20">
                  <div class="fw-bold">Authenticator App</div>
                  <div class="pl-12">
                    You can use an Authenticator App that will generate an
                    Authentication Code. The app will work even if your phone is
                    offline. The app will not have access to your password or
                    your account information.
                  </div>
                </div>
              </div>
              <div class="d-flex">
                <div class="fw-bold">2.</div>
                <div class="pl-20">
                  <div class="fw-bold">Text</div>
                  <div class="pl-12">
                    You can use your cellphone to receive an Authentication Code
                    via text. Message and data rates may apply.
                  </div>
                </div>
              </div>
              <div class="d-flex">
                <div class="fw-bold">3.</div>
                <div class="pl-20">
                  <div class="fw-bold">Email</div>
                  <div class="pl-12">
                    You can use your email address to receive an Authentication Code.
                  </div>
                </div>
              </div>
              <div class="text-left col-sm-12 footer-info">
                To Manage 2FA, click the
                <a
                  href="#"
                  onclick="openModule(addCsrfToken('/WebDispatch/Security.getMfaEnrollment'));"
                  >Manage 2FA</a
                >
                link.
              </div>
            </div>
          </div>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'mfa-workspace-default': MfaWorkspaceDefault;
    }
}

